import { FC } from 'react'
import { Button, H1 } from '@/common/ui'
import useBundleTrade from './useBundleTrade'
import { ORDER_FORM_COPY } from '@/locales/en'
import { Undo2Icon } from 'lucide-react'
import { ReviewItems } from './reviewItems'

export const OrderReview: FC = () => {
    return (
        <div className="self-stretch inline-flex flex-col justify-start items-center gap-4">
            <H1 className="self-stretch text-center text-black font-normal font-['Serious_Sans'] m-0 leading-9">
                {ORDER_FORM_COPY.reviewTitle}
            </H1>
            <ReviewItems />

            {ORDER_FORM_COPY.disclaimers.map((disclaimer, index) => (
                <div
                    key={index}
                    className="self-stretch justify-start text-content-secondary text-xs font-normal font-['Inter'] leading-4"
                >
                    {disclaimer}
                </div>
            ))}
        </div>
    )
}

export const OrderReviewButtons = ({ onSubmit, onBack }: { onSubmit: () => void; onBack: () => void }) => {
    const { submitSequential, isSubmitting } = useBundleTrade()

    const onOrderSubmit = async () => {
        await submitSequential()
        onSubmit()
    }

    return (
        <div className="w-full self-stretch inline-flex justify-between items-start gap-6">
            <Button
                variant={'outline'}
                disabled={isSubmitting}
                onClick={onBack}
                className="hidden sm:h-16 sm:inline-flex min-w-[100px] justify-center text-black text-sm items-center gap-2.5 font-medium font-['Inter'] leading-5"
            >
                <Undo2Icon size={16} />
                {ORDER_FORM_COPY.amend}
            </Button>
            <Button
                variant={'secondary'}
                loading={isSubmitting}
                onClick={onOrderSubmit}
                className="w-full sm:h-16 sm:w-auto inline-flex justify-center text-black text-sm items-center gap-2.5 font-medium font-['Inter'] leading-5"
            >
                {ORDER_FORM_COPY.submit}
            </Button>
        </div>
    )
}
